import Portfolio from '../portfolio';

/**
 * Create the action
 */

const { thunk, request, success, error } = Portfolio.destroy((id, fetch) => {
    return fetch.delete(`/portfolios/${id}`);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };